import React, { useState } from "react";
import {
  Box,
  Button,
  InputAdornment,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { IStoreState, useAppDispatch, useAppSelector } from "../../../../redux";
import {
  changeItemQuantitySync,
  insertItemIntoOrderSync,
  removeItemFromOrderSync,
} from "../../../../redux/orders";

import { IProduct } from "../../../../redux/inventory";
import { CustomizeProductDialog } from "./CustomizeProductDialog";
import { OutlinedTextField } from "../../../../Components/formComponents";
import { Add, AutoFixHigh, Remove } from "@mui/icons-material";
import { isNotNull } from "../../../../helpers/isNotNull";
import { useOutletContext } from "../../../../providers";

export interface IMenuProductCardProps {
  data: IProduct;
}

export const MenuProductCard: React.FC<IMenuProductCardProps> = ({ data }) => {
  const theme = useTheme();
  const isLightMode = theme.palette.mode === "light";
  const dispatch = useAppDispatch();
  const { default_tax_rate, OUTLET_CURRENCY_SYMBOL } = useOutletContext();
  const currentOrderInfo = useAppSelector(
    (state) => state.orders.single_order.data
  );
  const quantity = currentOrderInfo?.menu_items?.find(
    (item) => item.product_uuid === data.product_uuid
  )?.quantity;
  const customizer = useAppSelector((state: IStoreState) => state.customizer);
  const [openCustomizationDialog, setOpenCustomizationDialog] =
    useState<boolean>(false);
  const handleAddItemInOrder = () => {
    dispatch(
      insertItemIntoOrderSync({
        product: data,
        quantity: isNotNull(quantity) + 1,
        outletDefaultTax: isNotNull(default_tax_rate),
      })
    );
  };

  const handleRemoveItemFromOrder = () => {
    if (quantity && quantity > 0) {
      dispatch(
        removeItemFromOrderSync({
          product: data,
          quantity: isNotNull(quantity) - 1,
        })
      );
    }
  };

  const handleChangeProductQuantity = (itemQuantity: number) => {
    dispatch(
      changeItemQuantitySync({
        product: data,
        quantity: itemQuantity,
      })
    );
  };

  return (
    <Box
      display={"flex"}
      alignItems={"flex-start"}
      justifyContent={"flex-start"}
      bgcolor={theme.palette.mode === "dark" ? "#373837" : "#fff"}
      width="100%"
      mb={1}
    >
      <Paper
        square={false}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
          // bgcolor: "#2C2D2C",
          // color: "#FFFFFF",
          borderRadius: 1,
          width: "100%",
        }}
      >
        <Box
          width="20px"
          bgcolor={isLightMode ? "var(--secondary-color)" : "var(--primary-color)"}
          borderRadius={"8px 0 0 8px"}
        ></Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          width="calc(100% - 12px)"
          p={2}
        >
          <Box display={"flex"} alignItems="center" mb={1}>
            <Typography
              // color={"#FFFFFF"}
              fontSize={"1rem"}
              variant="h6"
              fontWeight={"medium"}
            >
              {data.category_name}
            </Typography>
            {data.is_out_of_stock && (
              <Typography
                color={"#545454"}
                variant="body2"
                fontWeight={"medium"}
                sx={{
                  background: "#ffe413",
                  paddingX: 1,
                  borderRadius: 0.5,
                  ml: 1,
                }}
              >
                Out of stock
              </Typography>
            )}
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="body1"
                fontWeight={"medium"}
                // color="#D0D0D0"
              >
                {data.product_name}
              </Typography>
              <Typography
                variant="body1"
                fontWeight={"medium"}
                // color="#D0D0D0"
              >
                {data.product_price_by === "WEIGHT"
                  ? `${OUTLET_CURRENCY_SYMBOL}${data.product_price}/${data.weight_per_unit}${data.product_weight_unit}`
                  : `${OUTLET_CURRENCY_SYMBOL}${data.product_price}`}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              <Button
                size="small"
                variant="contained"
                sx={{
                  minWidth: "35px",
                  height: "35px",
                  backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
                  color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
                  border: isLightMode ? "1px solid var(--border-light-color)" : "1px solid var(--border-dark-color)",
                  "&:hover": {
                    backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--tertiary-color)",
                    opacity: isLightMode ? 0.85 : 1,
                  }
                }}
                disabled={data.is_out_of_stock}
                onClick={handleRemoveItemFromOrder}
              >
                <Remove />
              </Button>
              <Box sx={{
                  width:
                  data.product_price_by === "WEIGHT"
                    ? "80px"
                    : "60px !important",
                    height: "35px",
              }}>
                {" "}
                <OutlinedTextField
                  sx={{
                  
                    "& .MuiOutlinedInput-root": {
                      height: "35px",
                      backgroundColor: "transparent",
                      color: "#FFFFFF",
                      "& fieldset": {
                        borderColor: "#C4C7C4",
                      },
                      // "&:hover fieldset": {
                      //     borderColor: "#FFFFFF"

                      // }
                    },
                    // "& input[type=number]": {
                    //     "-moz-appearance": "textfield",
                    // },
                    // "& input[type=number]::-webkit-outer-spin-button": {
                    //     "-webkit-appearance": "none",
                    //     margin: 0,
                    // },
                    // "& input[type=number]::-webkit-inner-spin-button": {
                    //     "-webkit-appearance": "none",
                    //     margin: 0,
                    // },
                    // "& .MuiOutlinedInput-input": {
                    //     padding: "6px 6px",
                    //     textAlign: "center",
                    //     color: '#FFFFFF'
                    // },
                  }}
                  style={{
                    width:
                      data.product_price_by === "WEIGHT"
                        ? "80px"
                        : "60px !important",
                  }}
                  type="number"
                  disabled={data.is_out_of_stock}
                  value={quantity || 0}
                  onChange={(evt) => {
                    if (Number(evt.target.value) >= 0) {
                      handleChangeProductQuantity(Number(evt.target.value));
                    }
                  }}
                  InputProps={{
                    endAdornment: data.product_price_by === "WEIGHT" && (
                      <InputAdornment position="end">
                        <Typography variant="body2" color="#FFFFFF">
                          {data.product_weight_unit}
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Button
                size="small"
                variant="contained"
                sx={{
                  minWidth: "35px",
                  height: "35px",
                  backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
                  color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
                  border: isLightMode ? "1px solid var(--border-light-color)" : "1px solid var(--border-dark-color)",
                  "&:hover": {
                    backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--tertiary-color)",
                    opacity: isLightMode ? 0.85 : 1,
                  },
                }}
                disabled={data.is_out_of_stock}
                onClick={handleAddItemInOrder}
              >
                <Add />
              </Button>

              <Button
                size="small"
                variant="contained"
                sx={{
                  minWidth: "35px",
                  height: "35px",
                  backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--primary-color)",
                  color: isLightMode ? "var(--text-light-color)" : "var(--text-dark-color)",
                  border: isLightMode ? "1px solid var(--border-light-color)" : "1px solid var(--border-dark-color)",
                  "&:hover": {
                    backgroundColor: isLightMode ? "var(--secondary-color)" : "var(--tertiary-color)",
                    opacity: isLightMode ? 0.85 : 1,
                  },
                }}
                disabled={data.is_out_of_stock}
                onClick={() => setOpenCustomizationDialog(true)}
              >
                <AutoFixHigh />
              </Button>
            </Box>
          </Box>
        </Box>
      </Paper>

      {openCustomizationDialog && (
        <CustomizeProductDialog
          open={openCustomizationDialog}
          product={data}
          onClose={() => setOpenCustomizationDialog(false)}
        />
      )}
    </Box>
  );
};
